import React, { useEffect, useState } from 'react';

// Pequeno aviso no topo da tela enquanto o histórico antigo é buscado na Binance e
// processado. Só aparece se a espera passar de SHOW_DELAY_MS (cargas rápidas não
// piscam) e some assim que a nova fatia de velas é montada.
export const HISTORY_INDICATOR_DELAY_MS = 250;

export interface HistoryLoadingIndicatorProps {
  isLoading: boolean;
}

export const HistoryLoadingIndicator = React.memo<HistoryLoadingIndicatorProps>(({ isLoading }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setVisible(false);
      return;
    }
    const id = setTimeout(() => setVisible(true), HISTORY_INDICATOR_DELAY_MS);
    return () => clearTimeout(id);
  }, [isLoading]);

  if (!visible) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="history-loading"
      className="absolute top-3 md:top-4 left-1/2 -translate-x-1/2 z-[95] pointer-events-none animate-in fade-in duration-300"
    >
      <div className="relative overflow-hidden bg-[#0a0e27]/85 backdrop-blur-md border border-[#00d9ff]/40 text-[#00d9ff] px-4 py-1.5 rounded-full font-mono text-[9px] md:text-[10px] uppercase tracking-[0.18em] shadow-[0_0_20px_rgba(0,217,255,0.25)] flex items-center gap-2">
        <span className="w-1.5 h-1.5 rounded-full bg-[#00d9ff] animate-pulse" />
        Sincronizando fluxo quântico...
        <span className="absolute bottom-0 left-0 h-[2px] w-full bg-gradient-to-r from-transparent via-[#00d9ff] to-transparent animate-pulse" />
      </div>
    </div>
  );
});
